<script setup lang="ts">
import { onMounted } from 'vue'
import { useUiStore } from '@/stores/ui'

const uiStore = useUiStore()

const THEME_STORAGE_KEY = 'fuelflow-theme'

// Apply saved theme on app mount to ensure persistence across all routes
onMounted(() => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY)
    if (saved) {
      const theme = JSON.parse(saved)
      Object.entries(theme).forEach(([key, value]) => {
        document.documentElement.setAttribute(key, value as string)
      })

      // Apply body classes for layout modes
      const body = document.body
      body.classList.remove('mini-sidebar', 'expand-menu', 'layout-box-mode')

      if (theme['data-layout'] === 'mini' || theme['data-size'] === 'compact') {
        body.classList.add('mini-sidebar')
      }

      if (theme['data-width'] === 'box') {
        body.classList.add('layout-box-mode', 'mini-sidebar')
      }
    }
  } catch (e) {
    console.warn('Failed to apply saved theme:', e)
  }
})
</script>

<template>
  <div class="min-h-screen">
    <router-view />

    <!-- Global notifications -->
    <div class="fixed top-4 right-4 z-50 space-y-2">
      <div
        v-for="notification in uiStore.notifications"
        :key="notification.id"
        class="bg-white rounded-lg shadow-lg p-4 max-w-md border-l-4 transition-all"
        :class="{
          'border-green-500': notification.type === 'success',
          'border-red-500': notification.type === 'error',
          'border-yellow-500': notification.type === 'warning',
          'border-blue-500': notification.type === 'info',
        }"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1">
            <h4 class="font-semibold text-gray-900">
              {{ notification.title }}
            </h4>
            <p v-if="notification.message" class="text-sm text-gray-600 mt-1">
              {{ notification.message }}
            </p>
          </div>
          <button
            @click="uiStore.removeNotification(notification.id)"
            class="ml-4 text-gray-400 hover:text-gray-600"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
